/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/9/22, 10:45 AM
 *
 */

import ToastBase from './ToastBase';

export default ToastBase;
